var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC6Icon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_29636_344502",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_29636_344502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7711 37.5C11.0598 37.5 10.4474 37.2433 9.93406 36.73C9.42073 36.2167 9.16406 35.6043 9.16406 34.8929V5.10708C9.16406 4.39569 9.42073 3.78333 9.93406 3.27C10.4474 2.75667 11.0598 2.5 11.7711 2.5H28.2236C28.935 2.5 29.5474 2.75667 30.0607 3.27C30.5741 3.78333 30.8307 4.39569 30.8307 5.10708V34.8929C30.8307 35.6043 30.5741 36.2167 30.0607 36.73C29.5474 37.2433 28.935 37.5 28.2236 37.5H11.7711ZM19.9974 24.1454C21.5799 24.1454 23.1064 24.3481 24.577 24.7533C26.0475 25.1583 27.4341 25.7221 28.7366 26.4446V8.56833H11.2582V26.4446C12.5793 25.7221 13.9705 25.1583 15.4316 24.7533C16.893 24.3481 18.4149 24.1454 19.9974 24.1454ZM20.0228 21.5942C18.7759 21.5942 17.7138 21.1583 16.8366 20.2867C15.9593 19.4153 15.5207 18.3525 15.5207 17.0983C15.5207 15.8511 15.9566 14.7872 16.8282 13.9067C17.6996 13.0258 18.7589 12.5854 20.0061 12.5854C21.2603 12.5854 22.326 13.0229 23.2032 13.8979C24.0802 14.7732 24.5186 15.8343 24.5186 17.0813C24.5186 18.3354 24.083 19.4011 23.2116 20.2783C22.3399 21.1556 21.277 21.5942 20.0228 21.5942Z",
    fill: "#1C1B1F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC6Icon);
export default __webpack_public_path__ + "static/media/c6Icon.e7b30761d5f611562d459e7abfcdb6c7.svg";
export { ForwardRef as ReactComponent };